import styled from 'styled-components';
import { Header as CustomHeader } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  flex: 1;
`;

export const ContainerChart = styled.div`
  display: flex;
`;

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 40px;
  gap: 10px;
`;

export const ContainerColorDescription = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const DescriptionColor = styled.div`
  height: 20px;
  width: 20px;
  background-color: ${(props) => props.color};
  margin: 10px 10px 0 0;
  border-radius: 4px;

`;

export const DescriptionText = styled.p`
`;

export const Header = styled(CustomHeader)`
  color: ${(props) => props.theme.color.text};
`;
